import React from 'react'
import img5 from '../Assets/img5.jpg'
import {motion} from "framer-motion"
import {fadeIn} from '../variant'

const About = () => {
  return (
    <div className='md:px-24 p-4 mx-auto'>
      
      <div className='flex flex-col md:flex-row justify-between items-center gap-10'>
          <motion.div
          variants={fadeIn("right", 0.2)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.7}}
          >
            <img src={img5} alt="" className='lg:h-[386px]' />
          </motion.div>

           <motion.div
           variants={fadeIn("left", 0.2)}
           initial="hidden"
           whileInView={"show"}
           viewport={{ once: false, amount: 0.7}}
           className='md:w-3/5'>
          <h2 className='md:text-lg text-lg text-justify'>La comptabilité de base désigne l'ensemble des principes et pratiques essentiels à la gestion financière d'une entreprise ou d'une organisation. 
            Elle permet de suivre les flux financiers (entrées et sorties d'argent) et d'assurer une gestion correcte des comptes. Elle est essentielle pour la gestion financière quotidienne 
            d'une entreprise, même à petite échelle Voici les principales notions de la comptabilité de base: 
            enregistrement des transactions, classement des comptes, le bilan, des rapports financiers et gestion de la trésorerie. <br /> En résumé, la comptabilité de base fournit les outils 
            nécessaires pour suivre la santé financière de l'entreprise, respecter les obligations légales et fiscales, et prendre des décisions économiques rationnelles.</h2>
        </motion.div>
        </div>
        
    </div>
  )
}

export default About